<template>
  <div 
    class="pa-4 mt-2">
    <v-layout wrap>
      <v-flex>
        <section>
          <v-row
            class="">
            <v-col 
              cols="12">
              <v-card 
                flat
                style="background: #fff;">
                <v-card-text style="min-height: calc(100vh - 245px)">
                  <div class="black--text fs-16 font-weight-bold mb-5">
                    Ubah Jadwal Visit Customer Untul Sales {{ sales_name }}
                  </div>
                  <ValidationObserver 
                    ref="form">
                    <v-form>
                      <!-- <div
                        class="mb-4">
                        <div 
                          class="body-2 mb-2">
                          Poto Profil
                        </div>

                        <uploadfolder v-if="form.image_url === ''"
                          v-model="upload.image">
                          <div 
                            slot="activator">
                            <v-card 
                              flat
                              width="200"
                              height="200"
                              class="d-flex align-center justify-center cursor-pointer"
                              style="border-radius: 15px;
                                    border: 2px solid #EBEBEB; 
                                    border-style: dashed;">
                              <v-avatar v-if="!process.image"
                                v-ripple
                                tile 
                                width="200"
                                height="200">
                                <v-icon
                                  size="50"
                                  color="#B9B9B9">
                                  mdi-cloud-upload-outline
                                </v-icon>
                              </v-avatar>

                              <v-progress-circular v-else
                                indeterminate
                                :color="set_color">
                              </v-progress-circular>
                            </v-card>
                          </div>
                        </uploadfolder>

                        <v-card v-if="form.image_url !== ''"
                          flat
                          width="200"
                          height="200"
                          class="d-flex align-center justify-center"
                          style="border-radius: 15px;
                                border: 2px solid #EBEBEB; 
                                border-style: dashed;">
                          <v-avatar
                            v-ripple
                            tile 
                            size="200"
                            style="border-radius: 15px;">
                            <v-img 
                              contain
                              width="100%"
                              height="100%"
                              alt="Distributor Amanata" 
                              :src="form.image_url"
                              class="ma-auto"
                              style="border-radius: 15px;">
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height"
                                  align="center"
                                  justify="center">
                                  <v-progress-circular 
                                    indeterminate 
                                    :color="set_color">
                                  </v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>
                          </v-avatar>

                          <v-icon 
                            @click="form.image_url = ''"
                            color="red"
                            class="cursor-pointer"
                            style="position: absolute; top: -10px; right: -10px;">
                            mdi-close-circle
                          </v-icon>
                        </v-card>
                      </div> -->

                      <v-row>

                        <v-col
                          cols="12"
                          md="12" class="pt-0">
                        
                          <!-- <ValidationProvider
                            name="Customer" 
                            rules="required" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-15 label-input">
                              <span class="red--text">*</span>
                              Customer
                            </div>

                            <v-autocomplete
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo

                              v-on:change="fetchToko()"
                              :readonly="form.sales_id === ''"

                              color="#4828a1"
                              placeholder="Customer"

                              
                              :items="customer"
                              item-value="id"
                              item-text="name"
                              :item-color="set_color"

                              v-model="form.customer_id"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-autocomplete>
                          </ValidationProvider> -->

                          <ValidationProvider
                            name="Toko" 
                            rules="required" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-15 label-input">
                              <!-- <span class="red--text">*</span> -->
                              Toko <div class="fs-13">(Nama Toko - Nama Customer - Sugest Jadwal Visit)</div>
                            </div>

                            <v-autocomplete
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo

                              color="#4828a1"
                              placeholder="Nama Toko - Nama Customer - Sugest Jadwal Visit"

                              
                              :items="toko"
                              item-value="id"
                              :item-text="toko => `${toko.name} - ${toko.customer_name} - ${toko.schedule_note === '' ? 'Tidak ada sugest jadwal visit' : toko.schedule_note}`"
                              @change="toko.forEach(obj => { if (obj.id === form.store_id) { form.customer_id = obj.customer_id } }); data_toko[0] = toko.find(obj => obj.id === form.store_id)"
                              :item-color="set_color"

                              v-model="form.store_id"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:selection="{ item }">
                                <div>
                                  {{ item.name }} - {{ item.customer_name }} - {{ item.schedule_note === '' ? 'Tidak ada sugest jadwal visit' : item.schedule_note }}
                                </div>
                              </template>

                              <template v-slot:item="{ item }">
                                <div>
                                  {{ item.name }} - {{ item.customer_name }} - {{ item.schedule_note === '' ? 'Tidak ada sugest jadwal visit' : item.schedule_note }}
                                </div>
                              </template>
                            </v-autocomplete>
                          </ValidationProvider>


                          <div v-if="form.store_id !== '' && form.store_id !== null">
                            <v-card
                              flat
                              style="border: 2px dashed #e0e0e0; border-radius: 10px;">
                              <v-card-text>
                                <div class="black--text fs-15 mb-3">
                                  Alamat Toko
                                </div>
                                <div class="fs-14 black--text">
                                  {{ data_toko[0].address }},{{ data_toko[0].village_name }}, {{ data_toko[0].subdistrict_name }}, {{ data_toko[0].city_name }}, {{ data_toko[0].province_name }}
                                </div>
                              </v-card-text>
                            </v-card>
                          </div>
                        </v-col>
                        
                        <v-col
                          cols="12"
                          md="12" class="">
                          
                          <div class="fs-15 label-input">
                          <!-- <span class="red--text">*</span> -->
                          
                            Tanggal Visit
                          </div>
            
                          <v-menu
                            v-model="menu2"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                            >
                            <template v-slot:activator="{ on, attrs }">
                              <ValidationProvider 
                                name="Tanggal Visit" 
                                rules="required" 
                                v-slot="{ errors }">
                                <v-text-field
                                  v-model="form.date"
                                  
                                  v-on:keyup.enter="save()"
                                  
                                  filled
                                  solo
                                  rounded
                                  dense
                                  
                                  :color="set_color"
                                  placeholder="Tanggal Visit"
            
            
                                
            
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                  >
                                </v-text-field>
                              </ValidationProvider>
                            </template>
                            <v-date-picker
                              v-model="form.date"
                              :min="new Date().toISOString().substr(0, 10)"
                              @input="menu2 = false"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>
                      </v-row>

                    </v-form>
                  </ValidationObserver>

                  <div v-if="message.error.length > 0"
                    class="text-center my-4 d-flex align-center">
                    <div
                      class="error--text">
                      <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                      
                      <span
                        class="ml-1">
                        {{ message.error }}
                      </span>
                    </div>
                  </div>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn 
                    @click="save()"
                    :loading="process.form"
                    :disabled="process.form"
                    width="190"
                    height="45"
                    elevation="0"
                    color="#6948c6"
                    class="fs-16 white--text text-capitalize border-radius">
                    Simpan
                  </v-btn>
                  
                  <v-btn
                    @click="() => $router.go(-1)"
                    :disabled="process.form"
                    color="red"
                    elevation="0"
                    width="140"
                    height="45"
                    class="body-2 white--text text-capitalize d-flex align-center ml-4 border-radius"
                    style="font-weight: 600;">
                  
                      Batal
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>

          <!-- <v-row
            justify="end"
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              md="12"
              class="d-flex align-center justify-end py-0">
              <v-btn 
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                width="190"
                height="45"
                elevation="0"
                color="#6948c6"
                class="fs-16 white--text text-capitalize border-radius">
                Simpan
              </v-btn>
              
              <v-btn
                @click="() => $router.go(-1)"
                :disabled="process.form"
                color="red"
                elevation="0"
                width="140"
                height="45"
                class="body-2 white--text text-capitalize d-flex align-center ml-4 border-radius"
                style="font-weight: 600;">
              
                  Batal
              </v-btn>
            </v-col>
          </v-row> -->
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        
        date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        menu: false,
        modal: false,
        menu2: false,
        
        form: {
          id: '',
          sales_id: '',
          customer_id: '',
          date: '',
          store_id: ''
        },
        name_toko: '',
        data_toko: [],
        

        customer: [],
        toko: [],
        sales_region_id: '',
        sales_name: '',

        sales: [],

        upload: {
          ttd: null,
          faktur: null
        },

        process: {
          form: false,

          ttd: false,

          faktur: false
        },
        
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
    },
    watch: {
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      this.fetchDetail()
    },
    methods: {
      async fetchDetail () {
        let params = {
          id: this.$route.query.id,
          sales_id: this.$route.params.id
        }

        await get('admin/jadwal/detail', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.form.id = res.results.data[0].id
            this.form.sales_id = res.results.data[0].sales_id
            this.form.customer_id = res.results.data[0].customer_id
            this.form.date = res.results.data[0].date
            // this.form.store_id = res.results.data[0].store_id
            this.name_toko = res.results.data[0].store_name
          }
          this.fetchSales()
          // this.fetchToko()
          
        })
      },
      changeStore(name) {
        this.toko.map(obj => {
          if (obj.name === this.name_toko) {
            this.form.store_id = obj.id
          }
        })
        this.data_toko[0] = this.toko.find(obj => obj.id === this.form.store_id)
      },
      async fetchSales () {
        this.process.load = true

        let params = {
          'category_user_id[eq]': '8',
          limit: 1000000
          // limit: 1000000,
          // par_id: '1'
        }

        await get(`admin/user/data`, { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.sales = res.results.data
            this.changeSales()
            this.fetchToko()
          }
          this.process.load = false
        })
      },
      async fetchCustomor () {
        // this.process.load = true

        // this.limit = pagination.row

        let params = {
          limit: 10000000000000,
          status: 'approved',
          sales_region_id: this.sales_region_id
        }

        // admin/services/data
        
        await get(`admin/customer/data`, { params })
        .then(response => {
          let res = response.data
          
          
          if (res.status === 200) {
            this.customer = res.results.data
            if (this.form.id !== '') {
              this.fetchEditToko()
            }
          }
        })
      },
      async fetchToko() {
        
        this.toko = []
        let params = {
          sales_region_id: this.sales_region_id,
          pagination_bool: false,
          status: 'approved'
          // id: this.form.customer_id
        }
  
        await get('admin/toko/data', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.toko = res.results.data
            this.changeStore()
          }
        })
      },
      async fetchEditToko() {
        
        // this.toko = []
        // let params = {
        //   id: this.form.customer_id
        // }
  
        // await get('admin/customer/detail', { params })
        // .then(response => {
        //   let res = response.data
            
        //   if (res.status === 200) {
        //     this.toko = res.results.data.store
        //   this.changeStore()
        //   }
        // })
      },
      changeSales() {
        this.sales.map(obj => {
          if (obj.id === this.form.sales_id) {
            this.sales_region_id = obj.sales_region_id
            this.sales_name = obj.name
          }
        })

        this.fetchCustomor()
      },
      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()
        if (isValid) {
          let form = {
            ...this.form
          }
          this.process.form = true

          // SAVE TO REST API
          await post(`admin/jadwal/update`, {
            data: form
          })
          .then((response) => {
            let res = response.data

            this.process.form = false

            if (res.status === 200) {

              this.$router.push({ path: `/visit/jadwal/detail/${this.form.sales_id}` })

            } else {
              this.message.error = res.message
            }
          })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      }
    }
  }
</script>